import React from 'react';

class KioskDeploymentSetUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deploymentSet: 'release',
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  handleSelect(event) {
    this.setState({ deploymentSet: event.target.value });
  }

  handleUpdate() {
    const { onDone } = this.props;
    onDone(this.state.deploymentSet);
  }

  render() {
    let { onCancel, selectedHostInfoList, kvsList } = this.props;
    let { deploymentSet } = this.state;
    let kvsSelectList = _toSelectList(kvsList);

    return (
      <div style={{ width: 600, fontSize: 18 }}>
        <h1>Update Deployment Set for {selectedHostInfoList.length} Kiosks</h1>
        <div className='pure-g' style={{ marginBottom: 20 }}>
          <select className='pure-u-1-1' value={deploymentSet} onChange={this.handleSelect}>
            {kvsSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </select>
        </div>

        <div className='modalFooter pure-g' style={{ textAlign: 'right' }}>
          <div className='pure-u-5-24'></div>
          <div className='pure-u-6-24'>
            <button className='pure-button button-regular button-aux' onClick={onCancel}>
              Cancel
            </button>
          </div>
          <div className='pure-u-1-24'></div>
          <div className='pure-u-12-24'>
            <button
              className='pure-button button-regular button-accent'
              onClick={this.handleUpdate}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function _toSelectList(kvsList) {
  let kvObjList =
    [{ key: '', value: '-Clear Deployment Set (disable scheduled update)-' }];
  for (let kvs of kvsList) {
    kvObjList.push({ key: kvs.name, value: kvs.name });
  }
  return kvObjList;
}

export default KioskDeploymentSetUpdate;



// WEBPACK FOOTER //
// ./src/components/KioskDeploymentSetUpdate.js